import React, { useEffect, useState } from "react";
import { Popover, Image, List, Text } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";

const tableActionsStyles = {
  overlayStyle: {
    border: `1px solid ${variables.grey5}`,
    backgroundColor: variables.bodyBg,
  },
  overlayInnerStyle: {
    padding: 0,
  },
  listStyle: {
    width: variables.actionListWidth,
    padding: variables.actionListPadding,
  },
  listHeaderText: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.secondaryGrey2,
    padding: variables.listItemPadding,
  },
  listItemStyle: { cursor: "pointer", padding: variables.listItemPadding },
  listItemTextStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.grey900,
  },
  actionIconStyle: {
    cursor: "pointer",
    width: variables.actionIconSize,
    height: variables.actionIconSize,
  },
};

const customItemRender = (item, handleAction) => {
  return (
    <List.Item
      key={item}
      style={tableActionsStyles.listItemStyle}
      onClick={(e) => handleAction(item?.action, e)}
    >
      <List.Item.Meta
        title={
          <Text style={tableActionsStyles.listItemTextStyle}>{item.label}</Text>
        }
      />
      {item.icon}
    </List.Item>
  );
};

const TableActions = ({
  tableActionsOptions,
  openPopover,
  stopPropagation,
}) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    if (openPopover) setOpen(openPopover);
    else {
      hide();
    }
  }, [openPopover]);

  const hide = () => {
    setOpen(false);
  };

  const handleAction = (action, e) => {
    e.stopPropagation();
    hide();
    action();
  };

  return (
    <Popover
      open={open}
      placement="leftTop"
      trigger="click"
      arrow={false}
      content={
        <List
          gutter={"1rem"}
          style={tableActionsStyles.listStyle}
          itemLayout="horizontal"
          dataSource={tableActionsOptions}
          renderItem={(item) => customItemRender(item, handleAction)}
        />
      }
      overlayStyle={tableActionsStyles.overlayStyle}
      overlayInnerStyle={tableActionsStyles.overlayInnerStyle}
      onOpenChange={handleOpenChange}
      onClick={(e) => {
        stopPropagation && e.stopPropagation();
      }}
    >
      <Image
        style={tableActionsStyles.actionIconStyle}
        preview={false}
        src={open ? "/actionIconSelected.png" : "/action.jpg"}
        alt="icon"
      />
    </Popover>
  );
};

export default TableActions;
